import React, { useCallback } from 'react'

export const useFormValidation = <T extends object>(
  rules: {
    [key in keyof T]?: ((
      value: T[key],
      formData: Partial<T>,
    ) => string | React.ReactElement | undefined)[]
  },
  isEmptyDefault: boolean = true,
) => {
  const validateForm = useCallback(
    (formData: Partial<T>, keys: (keyof T)[]) => {
      const errors: { [key in keyof T]?: string | React.ReactElement } = !isEmptyDefault
        ? keys.reduce(
            (acc, key) => ({
              ...acc,
              [key]: undefined,
            }),
            {},
          )
        : {}
      for (const key of keys) {
        const value = formData[key]
        const validators = rules[key]
        if (validators) {
          for (const func of validators) {
            errors[key] = func(value as never, formData)
            if (errors[key]) break
          }
        }
      }

      return errors
    },
    [rules],
  )

  return {
    validateForm,
  }
}
